import React from "react";
import SVG_POINTER from "../../../../assets/images/vector/components/common/pointer.svg";
import "./index.scss";

const POINTS_TEXT = [
  "Ncuentra productos rentables, las mejores palabras clave y proveedores verificados",
  "Deja que la IA gestione todo el proceso, desde mejorar una idea de producto hasta crear una publicación",
  "Logra libertad financiera e independencia para poder dejar tu empleo con confianza",
];
const STATIC_POINTS = POINTS_TEXT.map((text, i) => (
  <li key={i} className="PgESM-HI-D-points__item">
    <img className="PgESM-HI-D-points__pointer" src={SVG_POINTER} alt="-" />
    <p className="PgESM-HI-D-points__text">{text}</p>
  </li>
));

const Description = () => (
  <div className="PgESM-HI-D">
    <h2 className="PgESM-HI-D__title">
      Inicia y haz crecer tu negocio en Amazon
    </h2>
    <ul className="PgESM-HI-D-points">{STATIC_POINTS}</ul>
  </div>
);

export default Description;
